/**
 * Parts of a row's second line that are known, joined into one.
 *
 * The separator is what every list of label-plus-detail rows in Internal sets
 * between them, so a caller states the parts and never the punctuation.
 */
export const metaLine = (...parts: (string | null | undefined)[]): string =>
  parts.filter(Boolean).join(' · ')
